
import $ from "jquery"
import _template from "lodash/template"
import _once from "lodash/once"
import {Page} from "app/multi_device/index"
import NumbersFormatter from "app/numbers/formatter/index"
import legend_template from "./legend.html._tpl"
import legend_with_hr_template from "./legend_with_hr.html._tpl"
import mobile_legend_template from "./mobile_legend.html._tpl"


import I18n from "plugins/i18n-js"


const legend_tmpl = _template(legend_template)
const legend_with_hr_tmpl = _template(legend_with_hr_template)

const mobile_legend_tmpl = _template(mobile_legend_template)

// indicator for hide/show sub items
let show_other_fees_sub_item = false
let show_stamp_duties_sub_item = false

// pie chart height value
const PIE_CHART_HEIGHT_DEFAULT = 686

const PIE_CHART_HEIGHT_INCREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS = 30
const PIE_CHART_HEIGHT_INCREMENT_SHOW_OTHER_FEES_SUB_ITEMS = 61

// pie chart title and subtitle offset y value
const PIE_CHART_TITLE_OFFSETY_DEFAULT = -180
const PIE_CHART_SUBTITLE_OFFSETY_DEFAULT = -159.5

const PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS = 15
const PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS = 31

interface Selector {
  main: string,
}

const default_selector: Selector = {
  main: ".cell-real-estate-mortgages-calculator",
}

const isForListingPage = _once(() => {
  return $(default_selector.main).hasClass("cell-real-estate-mortgages-calculator--listing-page-desktop-ver") ||
    $(default_selector.main).hasClass("cell-real-estate-mortgages-calculator-listing-page--mobile")
})

const isForMobilePage = _once(() => {
  return $(default_selector.main).hasClass("cell-real-estate-mortgages-calculator--mobile")
})


const legend_setting = (loan_term_years: number, loan_term_months: number, total_cost: string | number): Highcharts.LegendOptions => {
  if (isForMobilePage()) {
    return {
      labelFormatter: function(){
        // this value NOT defined coz depends on chart type
        // For pie chart it's point object
        const self = this as unknown as Highcharts.Point
        return mobile_legend_tmpl({
          key:                          self.key,
          name:                         self.name,
          ad_valorem_stamp_duty:        NumbersFormatter.numberWithCommasAndCurrency((self.ad_valorem_stamp_duty || 0).toString(), 0),
          commission:                   NumbersFormatter.numberWithCommasAndCurrency((self.commission || 0).toString(), 0),
          legal_fee:                    NumbersFormatter.numberWithCommasAndCurrency((self.legal_fee || 0).toString(), 0),
          y:                            self.y !== null ? NumbersFormatter.numberWithCommasAndCurrency((self.y || 0).toString(), 0) : self.value,
          total_cost:                   total_cost,
        })
      },
      layout:           "vertical",
      useHTML:          true,
      itemMarginBottom: 20,

      itemStyle: {
        fontSize:   "12px",
        fontWeight: "normal",
      },
    }
    // TODO: separate Page difference logic by different object
  }
  if (isForListingPage()){
    return {
      labelFormatter: function(){
        // this value NOT defined coz depends on chart type
        // For pie chart it's point object
        const self = this as unknown as Highcharts.Point
        return legend_tmpl({
          key:                          null,
          show_other_fees_sub_item:     false,
          show_stamp_duties_sub_item:   false,
          name:                         self.name,
          y:                            NumbersFormatter.numberWithCommasAndCurrency((self.y || 0).toString(), 0),
        })
      },
      layout:           "vertical",
      align:            "right",
      verticalAlign:    "middle" ,
      useHTML:          true,
      itemMarginBottom: 10,
      itemMarginTop:    10,

      itemStyle: {
        fontSize:   "16px",
        fontWeight: "normal",
        fontFamily: "Lato",
      },
    }
  }

  // should be PageInstance.Enum.real_estate_mortgages_calculator_page
  return {
    labelFormatter: function(){
      // this value NOT defined coz depends on chart type
      // For pie chart it's point object
      const self = this as unknown as Highcharts.Point
      if (self.key === "other_fees") {
        return legend_with_hr_tmpl({
          name:                     self.name,
          y:                        NumbersFormatter.numberWithCommasAndCurrency((self.y || 0).toString(), 0),
          commission:               NumbersFormatter.numberWithCommasAndCurrency((self.commission || 0).toString(), 0),
          legal_fee:                NumbersFormatter.numberWithCommasAndCurrency((self.legal_fee || 0).toString(), 0),
          show_other_fees_sub_item: show_other_fees_sub_item,
          years:                    loan_term_years,
          months:                   loan_term_months,
          total_cost:               total_cost,
        })
      }
      return legend_tmpl({
        key:                        self.key,
        name:                       self.name,
        y:                          NumbersFormatter.numberWithCommasAndCurrency((self.y || 0).toString(), 0),
        ad_valorem_stamp_duty:      NumbersFormatter.numberWithCommasAndCurrency((self.ad_valorem_stamp_duty || 0).toString(), 0),
        show_stamp_duties_sub_item: show_stamp_duties_sub_item,
      })
    },
    layout:           "vertical",
    useHTML:          true,
    itemMarginBottom: 20,

    itemStyle: {
      fontSize:   "16px",
      fontWeight: "normal",
      fontFamily: "Lato",
    },
  }
}

function getPieChartHeight() {
  if (isForListingPage()) {
    return 306
  }

  else if (isForMobilePage()) {
    return 574
  }

  else {
    if (show_other_fees_sub_item && show_stamp_duties_sub_item){
      return PIE_CHART_HEIGHT_DEFAULT + PIE_CHART_HEIGHT_INCREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS + PIE_CHART_HEIGHT_INCREMENT_SHOW_OTHER_FEES_SUB_ITEMS
    }
    else if (show_stamp_duties_sub_item) {
      return PIE_CHART_HEIGHT_DEFAULT + PIE_CHART_HEIGHT_INCREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS
    }
    else if (show_other_fees_sub_item) {
      return PIE_CHART_HEIGHT_DEFAULT + PIE_CHART_HEIGHT_INCREMENT_SHOW_OTHER_FEES_SUB_ITEMS
    }
    return PIE_CHART_HEIGHT_DEFAULT
  }
}

function getPieChartTitleOffsetY() {
  if (isForListingPage()) {
    return Page.isForMobile() ? -60 : 18
  }

  else if (isForMobilePage()) {
    return -216
  }

  else {
    if (show_other_fees_sub_item && show_stamp_duties_sub_item) {
      return PIE_CHART_TITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS
    }
    else if (show_stamp_duties_sub_item) {
      return PIE_CHART_TITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS
    }
    else if (show_other_fees_sub_item) {
      return PIE_CHART_TITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS
    }
    return PIE_CHART_TITLE_OFFSETY_DEFAULT
  }
}

function getPieChartTitleOffsetX() {
  if (isForListingPage()) {
    return Page.isForMobile() ? 0 : -175
  }

  return 0
}

function getPieChartSubtitleOffsetY() {
  if (isForListingPage()) {
    return Page.isForMobile() ? -40 : 36
  }

  else if (isForMobilePage()) {
    return -199
  }

  else {
    if (show_other_fees_sub_item && show_stamp_duties_sub_item) {
      return PIE_CHART_SUBTITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS
    }
    else if (show_stamp_duties_sub_item) {
      return PIE_CHART_SUBTITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS
    }
    else if (show_other_fees_sub_item) {
      return PIE_CHART_SUBTITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS
    }
    return PIE_CHART_SUBTITLE_OFFSETY_DEFAULT
  }
}

function getPieChartSubtitleOffsetX() {
  if (isForListingPage()) {
    return Page.isForMobile() ? 0 : -175
  }

  return 0
}

function getPieChartBorderWidth() {
  if (isForMobilePage()) {
    return 20;
  }

  else if (isForListingPage()) {
    return 24
  }

  return 33
}

function getTitleText(total_cost: number | string, pmt_value: number) {
  if (isForListingPage()) {
    return total_cost.toString()
  }

  else if (isForMobilePage()) {
    return "$" + NumbersFormatter.numberWithCommas(Math.abs(pmt_value).toFixed(0))
  }

  return NumbersFormatter.numberWithCommasAndCurrency(pmt_value, 0)
}

let chart = null as null | Highcharts.Chart
const createPieChart = ({ad_valorem_stamp_duty, down_payment, loan_amount, total_interest, commission, legal_fee, total_cost, pmt_value, loan_term_years, loan_term_months}: {
  ad_valorem_stamp_duty: number,
  down_payment: number,
  loan_amount: number,
  total_interest: number,
  commission: number,
  legal_fee: number,
  total_cost: number | string,
  pmt_value: number,
  loan_term_years: number,
  loan_term_months: number,
}): void => {

  const title_font_size = Page.isForMobile() ? "18px" : "28px"
  const subtitle_font_size = Page.isForMobile() ? "12px" : "16px"

  const listingPageSubTitleText = I18n.t("concepts.real_estate.mortgages.calculator.data.headings.buying_cost")
  const subTitleText = I18n.t("concepts.real_estate.mortgages.calculator.data.labels.per_month")

  const other_fees = commission + legal_fee
  const stamp_duties = ad_valorem_stamp_duty
  // no need to destroy?
  // if (chart !== null) chart.empty().destroy()
  const options: Highcharts.Options = {
    chart: {
      animation:                false,
      spacingTop:               20,
      spacingBottom:            isForListingPage() ? 20 : 0,
      plotShadow:               false,
      type:                     "pie",
      height:                   getPieChartHeight(),
    },
    lang: {
      thousandsSep: ",",
    },
    title: {
      text:           getTitleText(total_cost, pmt_value),
      verticalAlign:  "middle",
      y:              getPieChartTitleOffsetY(),
      x:              getPieChartTitleOffsetX(),

      style: {
        fontSize:   title_font_size,
        fontWeight: "bold",
        fontFamily: "Lato",
      },
    },
    subtitle: {
      text:           isForListingPage() ? listingPageSubTitleText : subTitleText,
      verticalAlign:  "middle",
      y:              getPieChartSubtitleOffsetY(),
      x:              getPieChartSubtitleOffsetX(),

      style: {
        fontSize:   subtitle_font_size,
        fontFamily: "Lato",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor:           "pointer",
        dataLabels:       {
          enabled:        false,
        },

        showInLegend:     true,
        innerSize:        "100%",
        borderWidth:      getPieChartBorderWidth(),
        borderColor:      null,
        slicedOffset:     0,
      },
    },
    legend:   legend_setting(loan_term_years, loan_term_months, total_cost),
    credits:  {
      enabled: false,
    },
    tooltip: {
      formatter: function(){
        // this value defined in definition not picked up, Type script bug?
        const self = this as unknown as Highcharts.TooltipFormatterContextObject
        return `${self.point.name} (${NumbersFormatter.numberWithCommasAndCurrency(self.y.toString(), 0)})`
      },
      enabled: true,
    },
    series: [
      {
        type:         "pie",
        colorByPoint: true,
        data:         getHighChartData(),
      } as unknown as Highcharts.SeriesPieOptions,
    ],
  }

  function hideOrShowLegendSubItemStyling() {
    if (show_other_fees_sub_item && show_stamp_duties_sub_item) {
      chart?.setSize(0, PIE_CHART_HEIGHT_DEFAULT + PIE_CHART_HEIGHT_INCREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS + PIE_CHART_HEIGHT_INCREMENT_SHOW_OTHER_FEES_SUB_ITEMS)
      chart?.setTitle({y: PIE_CHART_TITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS})
      chart?.setSubtitle({y: PIE_CHART_SUBTITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS})
    }
    else if (show_stamp_duties_sub_item) {
      chart?.setSize(0, PIE_CHART_HEIGHT_DEFAULT + PIE_CHART_HEIGHT_INCREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS)
      chart?.setTitle({y: PIE_CHART_TITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS})
      chart?.setSubtitle({y: PIE_CHART_SUBTITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_STAMP_DUTIES_SUB_ITEMS})
    }
    else if (show_other_fees_sub_item) {
      chart?.setSize(0, PIE_CHART_HEIGHT_DEFAULT + PIE_CHART_HEIGHT_INCREMENT_SHOW_OTHER_FEES_SUB_ITEMS)
      chart?.setTitle({y: PIE_CHART_TITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS})
      chart?.setSubtitle({y: PIE_CHART_SUBTITLE_OFFSETY_DEFAULT - PIE_CHART_TITLE_AND_SUBTITLE_OFFSETY_DECREMENT_SHOW_OTHER_FEES_SUB_ITEMS})
    }
    else {
      chart?.setSize(0, PIE_CHART_HEIGHT_DEFAULT)
      chart?.setTitle({y: PIE_CHART_TITLE_OFFSETY_DEFAULT})
      chart?.setSubtitle({y: PIE_CHART_SUBTITLE_OFFSETY_DEFAULT})
    }
  }

  // Pie charts Data items group
  function getHighChartData() {
    if (isForListingPage()) {
      return listingPageMortgageCalculatorData()
    }
    else if(isForMobilePage()){
      return mobileMortgageCalculatorData()
    }
    return mortgageCalculatorData()
  }

  function listingPageMortgageCalculatorData() {
    return [
      {
        key:    "loan_amount",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.total_loan"),
        y:      (loan_amount),
        color:  "#BAE0C6",
        sliced: true,
      },
      {
        key:    "down_payment",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.down_payment"),
        y:      (down_payment),
        color:  "#2773B8",
        sliced: true,
      },
      {
        key:    "total_interest",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.total_interest"),
        y:      (total_interest),
        color:  "#53BACE",
        sliced: true,
      },
      {
        key:                    "stamp_duties",
        name:                   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.stamp_duty"),
        y:                      (stamp_duties),
        color:                  "#E7E9B3",
        ad_valorem_stamp_duty:  ad_valorem_stamp_duty,
        sliced:                 true,
      },
      {
        key:             "commission",
        name:            I18n.t("concepts.real_estate.mortgages.calculator.data.labels.commission.title"),
        y:               (commission),
        color:           "#DBDBDB",
        commission:      commission,
        legal_fee:       legal_fee,
        sliced:          true,
      },
    ]
  }

  function mortgageCalculatorData() {
    return [
      // dummy legend item(s) for spacing between chart and legend items group, will be removed if there is a better way for doing this
      {
        key:      "null",
        name:     "",
        y:        null,
        color:    "#FFF",
        enabled:  false,
      },
      // end of dummy item(s)
      {
        key:    "loan_amount",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.total_loan"),
        y:      (loan_amount),
        color:  "#BAE0C6",
        sliced: true,
      },
      {
        key:    "down_payment",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.down_payment"),
        y:      (down_payment),
        color:  "#2773B8",
        sliced: true,
      },
      {
        key:    "total_interest",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.total_interest"),
        y:      (total_interest),
        color:  "#53BACE",
        sliced: true,
      },
      {
        key:                    "stamp_duties",
        name:                   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.stamp_duties"),
        y:                      (stamp_duties),
        color:                  "#E7E9B3",
        ad_valorem_stamp_duty:  ad_valorem_stamp_duty,
        sliced:                 true,
        events:
        {
          legendItemClick:  (e: Event) => {
            e.preventDefault()
            if (show_stamp_duties_sub_item){
              show_stamp_duties_sub_item = false
            }
            else {
              show_stamp_duties_sub_item = true
            }
            hideOrShowLegendSubItemStyling()
          },
        },
      },
      {
        key:             "other_fees",
        name:            I18n.t("concepts.real_estate.mortgages.calculator.data.labels.other_fees"),
        y:               (other_fees),
        color:           "#DBDBDB",
        commission:      commission,
        legal_fee:       legal_fee,
        sliced:          true,
        events:
        {
          legendItemClick:  (e: Event) => {
            e.preventDefault()
            if (show_other_fees_sub_item) {
              show_other_fees_sub_item = false
            }
            else {
              show_other_fees_sub_item = true
            }
            hideOrShowLegendSubItemStyling()
          },
        },
      },
    ]
  }

  function mobileMortgageCalculatorData() {
    return [
      // dummy legend item(s) for spacing between chart and legend items group, will be removed if there is a better way for doing this
      {
        key:      "null",
        name:     "",
        y:        null,
        color:    "#FFF",
        enabled:  false,
      },
      // end of dummy item(s)
      {
        key:    "loan_amount",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.total_loan"),
        y:      (loan_amount),
        color:  "#BAE0C6",
        sliced: true,
      },
      {
        key:    "down_payment",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.down_payment"),
        y:      (down_payment),
        color:  "#2773B8",
        sliced: true,
      },
      {
        key:    "total_interest",
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.total_interest"),
        y:      (total_interest),
        color:  "#53BACE",
        sliced: true,
      },
      {
        key:                    "stamp_duties",
        name:                   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.stamp_duty"),
        y:                      (stamp_duties),
        color:                  "#E7E9B3",
        ad_valorem_stamp_duty:  ad_valorem_stamp_duty,
        sliced:                 true,
      },
      {
        key:             "other_fees",
        name:            I18n.t("concepts.real_estate.mortgages.calculator.data.labels.commission.title"),
        y:               (commission),
        color:           "#DBDBDB",
        commission:      commission,
        legal_fee:       legal_fee,
        sliced:          true,
      },
      {
        key:    null,
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.loan_term"),
        y:      null,
        value:  I18n.t("concepts.real_estate.mortgages.calculator.data.labels.years_and_months", {year: loan_term_years, month: loan_term_months}),
        color:  "#FFF",
        sliced: true,
        events:
        {
          legendItemClick:  (e: Event) => {
            e.preventDefault()
          },
        },
      },
      {
        key:    null,
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.number_of_instalments"),
        y:      null,
        value:  loan_term_years * 12 + loan_term_months,
        color:  "#FFF",
        sliced: true,
        events:
        {
          legendItemClick:  (e: Event) => {
            e.preventDefault()
          },
        },
      },
      {
        key:    null,
        name:   I18n.t("concepts.real_estate.mortgages.calculator.data.labels.total_cost"),
        y:      null,
        value:  total_cost,
        color:  "#FFF",
        sliced: true,
        events:
        {
          legendItemClick:  (e: Event) => {
            e.preventDefault()
          },
        },
      },

    ]
  }
  // end of Data items group


  import(
    "highcharts"
  )
  .then((Highcharts) => {
    // Workaround for "Highcharts is not defined"
    window.Highcharts = Highcharts
    const pie_chart: Highcharts.HTMLDOMElement = document.getElementById("cell-real-estate-mortgages-calculator_pie-chart") as Highcharts.HTMLDOMElement

    chart = new Highcharts.Chart(
      pie_chart,
      options,
      () => {
        // This is required for staging/dev due to an issue
        // that causes the chart not drawn on load
        // Thus `reflow` is called
        // No visual change if the chart is displayed correctly already (like prod)
        setTimeout(() => {
          chart?.reflow()
        }, 0)
        setTimeout(() => {
          chart?.reflow()
        }, 100)
        setTimeout(() => {
          chart?.reflow()
        }, 500)
      }
    )
  })
}


export default {
  create: createPieChart,
}
